module.exports = __webpack_public_path__ + "img/banner2.388772ce.png";